import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { AuthClientEvent } from '@react-keycloak/core';
import { DASHBOARD_PATH } from './util/const';
import PrivateRoute from './PrivateRoute';
import Dashboard from './Dashboard';
import './App.css';
import { DatabaseManager } from './services/DatabaseManager';


const App = () => {

  // This matches what we configured in Keycloak
  const keycloak = new Keycloak({
    url: process.env.REACT_APP_URL as string,
    realm: process.env.REACT_APP_KEYCLOAK_REALM as string,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT as string
  });

  const initOptions: KeycloakInitOptions = {
    onLoad: 'login-required', //make the keycloak login appear
    pkceMethod: "S256"
  };

  const setAuthToken = () => {
    DatabaseManager.getInstance().setToken(keycloak.token);
  }

  return (
    <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions} 
      autoRefreshToken={true}
      onEvent={((eventType: AuthClientEvent): void => {
        switch(eventType)
        {
          case 'onAuthSuccess': setAuthToken(); break;
          case 'onAuthError': console.log("Authentication Error"); break;
          case 'onTokenExpired': break;
          case 'onAuthRefreshSuccess': setAuthToken(); break;
          case 'onReady': break;
          default: console.log(eventType);
        }
      })}>
      <BrowserRouter>
        <Routes>
          <Route path={DASHBOARD_PATH} element={
            <PrivateRoute>
              <Dashboard />  
            </PrivateRoute>
          } />
          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />  
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </ReactKeycloakProvider>
  );
}

export default App;